module.exports = __webpack_public_path__ + "img/co-flag.836be539.png";